import fetch from "auth/FetchInterceptor";

const AdminService = {
  create: (data) => {
    return fetch({
      data: data,
      method: "post",
      url: `/admin/createAdmin`,
    });
  },
  deleteById: (id) => {
    return fetch({
      method: "delete",
      url: `/admin/deleteById/${id}`,
    });
  },
  editMyProfile: (data) => {
    return fetch({
      data: data,
      method: "put",
      url: `/admin/editMyprofil`,
    });
  },
  getAll: (page) => {
    return fetch({
      method: "get",
      url: `/admin/getAll?page=${page}`,
    });
  },
  getById: (id) => {
    return fetch({
      method: "get",
      url: `/admin/getById/${id}`,
    });
  },
  // eslint-disable-next-line no-unused-vars
  getMyProfile: (id) => {
    return fetch({
      method: "get",
      url: `/admin/profil`,
    });
  },
  getNombreDoctorsByState: () => {
    return fetch({
      method: "get",
      url: `/doctorOffice/doctorByWilaya`,
    });
  },
  getStatistics: () => {
    return fetch({
      method: "get",
      url: `/admin/statistics`,
    });
  },

  search: (page, fullName) => {
    let url = `/admin/getAll?page=${page}`;
    if (fullName) {
      url = `/admin/getAll?page=${page}&fullName=${fullName}`;
    }
    return fetch({
      method: "get",
      url: url,
    });
  },
};

export default AdminService;
